import { render } from "./ConsultForm.vue?vue&type=template&id=324f6d24"
import script from "./ConsultForm.vue?vue&type=script&lang=js"
export * from "./ConsultForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__